import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { 
  ArrowUpRight, ArrowDownLeft, Send, Scan, Receipt, 
  Wallet, Landmark, Eye, EyeOff, Bell,Globe,Smartphone, Plus,
  TrendingUp, TrendingDown, ChevronRight, Activity,
  HistoryIcon,
  CheckCircle2,
  Coins,
  ArrowRight,
  Sparkles
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatCurrency, formatDateTime, cn } from "../lib/utils";
import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const transfer = [
  { icon: Globe, label: "International", path: "/transfer/international", color: "text-blue-600", bg: "bg-blue-50" },
  { icon: Send, label: "Local", path: "/transfer/local", color: "text-emerald-600", bg: "bg-emerald-50" },
  { icon: Landmark, label: "Same Bank", path: "/transfer/same-bank", color: "text-purple-600", bg: "bg-purple-50" },
  { icon: Landmark, label: "Crypto", path: "/transfer/crypto", color: "text-purple-600", bg: "bg-purple-50" }
];

const quicklinks = [
  { icon: Smartphone, label: "Airtime", path: "/bills/airtime", color: "text-orange-600" },
  { icon: Receipt, label: "Pay Bills", path: "/bills", color: "text-slate-600" },
  { icon: Scan, label: "QR Pay", path: "/qr", color: "text-slate-600" }
];

export const Dashboard = () => {
  const { user, refreshUser } = useAuth();
  const [transactions, setTransactions] = useState([]);
  const [showBalance, setShowBalance] = useState(true);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ totalCredit: 0, totalDebit: 0 });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [txnRes] = await Promise.all([
        axios.get(`${API_URL}/transactions`),
        refreshUser(),
      ]);
      const txns = txnRes.data;
      setTransactions(txns.slice(0, 5));
      
      
      const totalCredit = txns.filter(t => t.transaction_type === "credit")
      const totalDebit = txns.filter(t => t.transaction_type === "debit").reduce((s, t) => s + t.amount, 0);
      setStats({ totalCredit, totalDebit });
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen animate-in fade-in slide-in-from-bottom-4 duration-700">
   
      <div className=" space-y-8 mt-6">
        {/* Visual Card Stack */}
        <div className="relative pt-4">
          <div className="absolute top-2 left-8 right-8 h-20 bg-slate-200 rounded-[2rem] -z-10 opacity-40 blur-sm" />
          <div className="absolute top-0 left-4 right-4 h-20 bg-slate-400 rounded-[2rem] -z-10 opacity-20" />
          
          <div className="bg-slate-900 rounded-[2.5rem] p-8 text-white shadow-2xl relative overflow-hidden ring-1 ring-white/10">
              {/* Card Glow Effect */}
              <div className="absolute -top-24 -right-24 w-48 h-48 bg-blue-500/20 rounded-full blur-3xl" />
              
              <div className="flex justify-between items-start mb-6">
                <div>
                  <p className="text-[11px] uppercase tracking-[0.2em] text-white/50 mb-1 font-bold">Available Balance</p>
                  <div className="flex items-center gap-3">
                    <h1 className="text-2xl font-bold tracking-tighter">
                      {showBalance ? formatCurrency(user?.available_balance || 0, user?.currency) : "••••••"}
                    </h1>
                    <button onClick={() => setShowBalance(!showBalance)} className="text-white/40 hover:text-white transition-colors">
                      {showBalance ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                </div>
                <div className="h-8 w-12 bg-white/10 rounded-lg flex items-center justify-center backdrop-blur-md border border-white/10">
                   <div className="flex -space-x-2">
                     <div className="w-4 h-4 rounded-full bg-orange-500/80" />
                     <div className="w-4 h-4 rounded-full bg-yellow-500/80" />
                   </div>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-2">
                   <p className="text-sm font-medium text-white/60">Current Balance:</p>
                   <p className="text-sm font-bold text-white/90">
                     {showBalance ? formatCurrency(user?.current_balance || 0, user?.currency) : "••••"}
                   </p>
                </div>

<div className="grid grid-cols-2 gap-4 pt-4 border-t border-white/10">
  {/* Last Credit */}
  <div className="flex items-center gap-2">
    <div className="w-7 h-7 rounded-lg bg-emerald-500/20 flex items-center justify-center">
      <TrendingUp size={14} className="text-emerald-400" />
    </div>
    <div>
      <p className="text-[11px] uppercase text-white/40 font-bold">Last Credit</p>
      <p className="text-sm font-bold">
        {/* Force to Number and check if it's a valid number */}
        {formatCurrency(!isNaN(parseFloat(stats?.totalCredit)) ? stats.totalCredit : 0, user?.currency)}
      </p>
    </div>
  </div>

  {/* Last Debit */}
  <div className="flex items-center gap-2">
    <div className="w-7 h-7 rounded-lg bg-red-500/20 flex items-center justify-center">
      <TrendingDown size={14} className="text-red-400" />
    </div>
    <div>
      <p className="text-[11px] uppercase text-white/40 font-bold">Last Debit</p>
      <p className="text-sm font-bold">
        {/* Force to Number and check if it's a valid number */}
        {formatCurrency(!isNaN(parseFloat(stats?.totalDebit)) ? stats.totalDebit : 0, user?.currency)}
      </p>
    </div>
  </div>
</div>
              </div>
          </div>
        </div>

      <div className="px-6 py-0">
        <div className="h-[2px] w-full bg-gradient-to-r from-transparent via-slate-200 to-transparent opacity-60" />
      </div>
 {/* Quick Actions Bento Grid */}
<section className="mt-8 px-1">
  <div className="flex items-end justify-between mb-5">
    <div>
      <h2 className="font-black text-sm text-slate-900 tracking-tight leading-none">Transfer</h2>
      <p className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mt-1">Send Swiftly</p>
    </div>
    <Link to="/transfer" className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100 group active:scale-95 transition-all">
      <ChevronRight className="w-4 h-4 text-slate-400 group-hover:text-slate-900" />
    </Link>
  </div>

  <div className="grid grid-cols-2 gap-3 h-[220px]">
    
      <Link 
      to={transfer[0].path}
      className={cn(
        "relative overflow-hidden rounded-[2.5rem] p-20 md:px-10 px-2 flex flex-col justify-between group active:scale-[0.97] transition-all duration-300 shadow-xl shadow-blue-500/10 border border-white/20",
        "bg-gradient-to-br from-blue-600 to-indigo-700"
      )}
    >
      <div className="absolute -top-4 -right-4 w-24 h-24 bg-white/10 rounded-full blur-2xl group-hover:bg-white/20 transition-colors" />
      <div className="w-12 h-12 rounded-2xl bg-white/10 backdrop-blur-md flex items-center justify-center border border-white/20 shadow-inner">
        <Send className="w-6 h-6 text-white" strokeWidth={2.5} />
      </div>
      <div>
        <p className="text-white font-black text-sm leading-tight">{transfer[0].label}</p>
        <p className="text-white/60 text-[12px] font-bold uppercase tracking-widest mt-1">Fast & Secure</p>
      </div>
    </Link>


    {/* Right Column Stack (Local & Same Bank) */}
    <div className="grid grid-rows-2 gap-3">
      {/* Local Transfer - Emerald/Green Theme */}
      <Link 
        to={transfer[1].path}
        className="rounded-[2rem] p-4 flex items-center gap-4 bg-emerald-50 border border-emerald-100 shadow-sm active:scale-[0.97] transition-all group overflow-hidden relative"
      >
        <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-sm transition-transform group-hover:rotate-12">
          <Send className="w-5 h-5 text-emerald-600" strokeWidth={2.5} />
        </div>
        <div className="z-10">
          <p className="text-sm font-black text-slate-900 leading-tight">Local</p>
          <p className="text-[11px] font-bold text-emerald-600/70 uppercase tracking-tighter mt-0.5">Instant</p>
        </div>
      </Link>

      {/* Same Bank Transfer - Indigo/Blue Theme */}
      <Link 
        to={transfer[2].path}
        className="rounded-[2rem] p-4 flex items-center gap-4 bg-indigo-50 border border-indigo-100 shadow-sm active:scale-[0.97] transition-all group overflow-hidden relative"
      >
        <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-sm transition-transform group-hover:rotate-12">
          <Landmark className="w-5 h-5 text-indigo-600" strokeWidth={2.5} />
        </div>
        <div className="z-10">
          <p className="text-sm font-black text-slate-900 leading-tight">Same Bank</p>
          <p className="text-[11px] font-bold text-indigo-600/70 uppercase tracking-tighter mt-0.5">Free</p>
        </div>
      </Link>
      <Link 
        to={transfer[3].path}
        className="rounded-[2rem] p-4 flex items-center gap-4 bg-orange-50 border border-orange-100 shadow-sm active:scale-[0.97] transition-all group overflow-hidden relative"
      >
        <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center flex-shrink-0 shadow-sm transition-transform group-hover:rotate-12">
          <Coins className="w-5 h-5 text-orange-600" strokeWidth={2.5} />
        </div>
        <div className="z-10">
          <p className="text-sm font-black text-slate-900 leading-tight">Crypto</p>
          <p className="text-[11px] font-bold text-orange-600/70 uppercase tracking-tighter mt-0.5">Network Fee</p>
        </div>
      </Link>
    </div>
  </div>
</section>

<br/><br/>

<section className="mt-8 px-1">
  <div className="flex items-center justify-between mb-5 px-1">
    <div>
      <h2 className="font-black text-sm text-slate-900 tracking-tight leading-none">Bill Payments</h2>
    </div>
    <div className="flex gap-1.5">
       <div className="w-1.5 h-1.5 rounded-full bg-slate-900" />
       <div className="w-1.5 h-1.5 rounded-full bg-slate-200" />
    </div>
  </div>

  {/* 2-Column Bento Grid */}
  <div className="grid grid-cols-2 gap-4">
    {[
      { name: "Amazon", sub: "Prime", color: "bg-[#FF9900]", icon: "A", amount: "$14.99", date: "Secured" },
      { name: "Netflix", sub: "Ultra HD", color: "bg-[#E50914]", icon: "N", amount: "$15.49", date: "Secured" },
      { name: "Spotify", sub: "Family", color: "bg-[#1DB954]", icon: "S", amount: "$9.99", date: "Secured" },
      { name: "Apple", sub: "One", color: "bg-slate-900", icon: "A", amount: "$19.95", date: "Secured" },
    ].map((service, i) => (
      <Link 
        key={i} 
        to={`/bills`}
        className="group relative bg-white rounded-[2.5rem] p-5 border border-slate-100 shadow-sm hover:shadow-xl hover:border-slate-200 transition-all duration-500 active:scale-95 overflow-hidden"
      >
        {/* Decorative background glow that matches brand color */}
        <div className={cn(
          "absolute -top-10 -right-10 w-24 h-24 opacity-5 blur-3xl rounded-full transition-opacity group-hover:opacity-20",
          service.color
        )} />

        <div className="flex justify-between items-start mb-6">
          <div className={cn(
            "w-10 h-10 rounded-2xl flex items-center justify-center text-white text-lg font-black shadow-lg shadow-black/5 transition-transform group-hover:scale-110 group-hover:rotate-3",
            service.color
          )}>
            {service.icon}
          </div>
        </div>

        <div>
          <h3 className="text-sm font-black text-slate-900 leading-tight">{service.name}</h3>
          <p className="text-[12px] font-bold text-slate-400 uppercase tracking-tight mt-0.5">{service.sub}</p>
        </div>

      </Link>
    ))}
  </div>
</section>

<section className="relative w-full group overflow-hidden rounded-[2rem] border border-slate-100 shadow-sm transition-all duration-500 hover:shadow-xl hover:border-primary/20 cursor-pointer">
      <Link to="/loans" className="block relative h-40 md:h-38">
        
        {/* The Image Wrapper */}
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&q=80&w=1200" 
            alt="Promotion"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          {/* Dark Overlay Gradient for Readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 via-slate-900/40 to-transparent" />
        </div>

        {/* Content Overlay */}
        <div className="relative h-full flex flex-col justify-center px-8 md:px-12 space-y-3 z-10">
          <div className="flex items-center gap-2">
            <div className="bg-primary/20 backdrop-blur-md p-1.5 rounded-lg border border-white/10">
              <Sparkles className="w-3 h-3 text-primary-foreground text-white" />
            </div>
            <span className="text-[12px] font-black uppercase tracking-[0.2em] text-white/80">
              Exclusive Offer
            </span>
          </div>

          <div className="max-w-md">
            <h2 className="text-lg md:text-2xl font-black text-white leading-tight">
              LOW INTEREST LOANS
            </h2>
            <p className="text-white/60 text-sm md:text-sm mt-2 font-medium">
              Zero collateral, instant disbursement. Terms & conditions apply.
            </p>
          </div>

        </div>

        {/* Subtle Glass Border Decoration */}
        <div className="absolute inset-2 rounded-[1.6rem] border border-white/5 pointer-events-none" />
      </Link>
    </section>

        {/* Recent Transactions */}
<section className="animate-in fade-in slide-in-from-bottom-8 duration-1000">
      {/* Header Section */}
      <div className="flex justify-between items-end mb-6 px-1">
        <div>
          <h2 className="font-black text-sm text-slate-900 tracking-tight leading-none">
            Recent Transactions
          </h2>
        </div>
        <Link 
          to="/transactions" 
          className="text-[12px] font-black uppercase tracking-widest text-slate-400 hover:text-slate-900 transition-colors"
        >
          See more
        </Link>
      </div>
      
      <div className="space-y-3">
        {loading ? (
          /* Skeleton Loader */
          [1, 2, 3, 4].map((i) => (
            <div 
              key={i} 
              className="h-20 bg-slate-50/50 rounded-[2rem] animate-pulse border border-slate-50" 
            />
          ))
        ) : transactions && transactions.length > 0 ? (
          /* Transaction List */
          transactions.map((txn, i) => (
            <Link 
              key={txn.id || i} 
              to={`/transactions/${txn.id}`} 
              className="group flex items-center justify-between p-4 bg-white border border-slate-100 rounded-[2rem] hover:shadow-xl hover:shadow-slate-200/50 hover:border-white transition-all duration-500 active:scale-[0.98]"
              style={{ animationDelay: `${i * 100}ms` }}
            >
              <div className="flex items-center gap-4">
                {/* Dynamic Icon Orb */}
                <div className={cn(
                  "w-12 h-12 rounded-2xl flex items-center justify-center transition-transform group-hover:scale-110 group-hover:rotate-6 shadow-sm",
                  txn.transaction_type === "credit" ? "bg-emerald-50" : "bg-slate-900"
                )}>
                  {txn.transaction_type === "credit" ? (
                    <ArrowDownLeft className="w-5 h-5 text-emerald-600" strokeWidth={3} />
                  ) : (
                    <ArrowUpRight className="w-5 h-5 text-white" strokeWidth={3} />
                  )}
                </div>

                <div>
                  <p className="text-[13px] font-black text-slate-900 leading-tight tracking-tight">
                    {txn.beneficiary_name || txn.narration || "External Transfer"}
                  </p>
                  <div className="flex items-center gap-2 mt-1">
                    <p className="text-[12px] text-slate-400 uppercase font-black tracking-tighter">
                      {formatDateTime ? formatDateTime(txn.created_at) : "Just now"}
                    </p>
                    <div className="w-1 h-1 rounded-full bg-slate-200" />
                    
                  </div>
                </div>
              </div>

              <div className="text-right">
                <p className={cn(
                  "text-sm font-black tracking-tighter",
                  txn.transaction_type === "credit" ? "text-emerald-600" : "text-slate-900"
                )}>
                  {txn.transaction_type === "credit" ? "+" : "-"} {formatCurrency ? formatCurrency(txn.amount, user?.currency) : txn.amount}
                </p>
                <div className="flex items-center gap-1">
                       <CheckCircle2 size={8} className="text-emerald-500" />
                       <p className="text-[12px] text-slate-400 uppercase font-black tracking-tighter">
                        Success
                       </p>
                    </div>
              </div>
            </Link>
          ))
        ) : (
          /* Empty State - Using the renamed HistoryIcon */
          <div className="flex flex-col items-center justify-center py-12 px-6 bg-slate-50/30 rounded-[3rem] border border-dashed border-slate-200">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-4 border border-slate-50">
              <HistoryIcon className="w-6 h-6 text-slate-300" />
            </div>
            <h3 className="text-sm font-black text-slate-900 uppercase tracking-widest">
              No transactions yet
            </h3>
            <p className="text-[11px] text-slate-400 font-bold text-center mt-2 max-w-[200px] leading-relaxed">
              Your recent activity will show up here once you send or receive money.
            </p>
            <Link 
              to="/transfer" 
              className="mt-6 flex items-center gap-2 bg-slate-900 text-white px-6 py-3 rounded-full text-[12px] font-black uppercase tracking-widest active:scale-95 transition-all shadow-lg shadow-slate-900/20"
            >
              <Send size={12} strokeWidth={3} />
              Start a Transfer
            </Link>
          </div>
        )}
      </div>
    </section>

<Link to="/loans" className="group block">
  <div className="relative overflow-hidden p-6 bg-slate-200 rounded-[2.5rem] border border-slate-800 shadow-2xl transition-all duration-500 group-hover:-translate-y-2 group-hover:shadow-primary/20">
    
    {/* High-End Glow Effects */}
    <div className="absolute -right-10 -top-10 w-40 h-40 bg-primary/20 rounded-full blur-[60px] group-hover:bg-primary/30 transition-colors duration-700" />
    <div className="absolute -left-10 -bottom-10 w-32 h-32 bg-blue-500/10 rounded-full blur-[50px]" />
    
    <div className="relative z-10">
      {/* Top Section: Badge & Icon */}
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-primary to-blue-600 p-[1px]">
            <div className="w-full h-full rounded-[15px] bg-slate-900 flex items-center justify-center text-white">
              <Wallet className="w-5 h-5 group-hover:rotate-12 transition-transform" />
            </div>
          </div>
          <span className="px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-[12px] font-black uppercase tracking-widest text-primary">
            Instant Credit
          </span>
        </div>
        
        <div className="w-10 h-10 rounded-2xl flex items-center justify-center text-white bg-primary group-hover:border-white transition-all duration-300">
          <ArrowRight className="w-5 h-5" />
        </div>
      </div>

      {/* Center Section: Typography */}
      <div className="space-y-2">
        <h3 className="text-lg font-black text-black tracking-tight">
          Get Access to Loan
        </h3>
        <p className="text-sm text-slate-900 leading-relaxed max-w-[220px]">
         Apply for loan with us with little or no collateral
        </p>
      </div>

      {/* Bottom Section: The "Limit" Pill */}
      <div className="mt-8 p-4 rounded-3xl bg-white/5 border border-black backdrop-blur-sm flex items-center justify-between group-hover:border-primary/30 transition-colors">
        <div className="flex flex-col">
          <span className="text-[11px] font-black uppercase tracking-widest text-slate-500">Max Application</span>
          <span className="text-sm font-black text-slate-900">
            {formatCurrency('5000000', user?.currency)}
          </span>
        </div>
        <div className="h-8 w-[1px] bg-white/10" />
        <div className="text-right">
          <span className="text-[11px] font-black uppercase tracking-widest text-slate-900">Interest</span>
          <p className="text-sm font-bold text-emerald-400">From 2.5%</p>
        </div>
      </div>
    </div>
  </div>
</Link>
      </div>

    </div>
  );
};